import { Typography } from '@mui/material';

export function Heading({ title }: { title: string }) {
  return (
    <Typography
      variant='h5'
      component='div'
      textAlign='center'
      mb={2}
      sx={{ textTransform: 'uppercase' }}
    >
      {title}
    </Typography>
  );
}
